import { Component, OnInit, ViewChild } from '@angular/core';
import { RecDateSearchRowVM, RecDocVM, GetRecDateSearchQuery, GetRecDateSearchReportQuery, SearchFilter } from '../../../shared/viewmodels/ISearchService';
import { DxDataGridComponent } from 'devextreme-angular';
import { CompoundNameComponent } from '../../../shared/components/compound-name/compound-name.component'
import { CoreSearchDataState as AppState, getRegSearchState } from '../../../store/reducers/reducers';
import { RecSearchService } from '../../rec-search-service';
import { Store } from '@ngrx/store';
import { take } from 'rxjs/operators';
import { ReportViewerService } from '../../../shared/services/report-viewer.service';
import { Router } from '@angular/router';
import CustomStore from 'devextreme/data/custom_store';
//import { listener } from '@angular/core/src/render3';

@Component({
  selector: 'app-rec-date-search-grid',
  templateUrl: './rec-date-search-grid.component.html',
  providers: [RecSearchService, ReportViewerService],
  styleUrls: ['./rec-date-search-grid.component.css']
})
export class RecDateSearchGridComponent implements OnInit {

  @ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;
  @ViewChild(CompoundNameComponent, { static: false }) cName: CompoundNameComponent;


  public errorMsg: string;
  public recsresults: any = {};//RecDateSearchRowVM[];
  public recdoc: RecDocVM;
  public re: string;
  applyFilterTypes: any;
  currentFilter: any;
  showFilterRow: boolean;
  console = console;
  towns: string[] = [];
  doctypes: string[] = [];
  public remoteOps: any = {};
  public infoFromServer: string;

  userInput: any;

  focusedRowKey: number;
  recordCount: number;

  constructor(private service: RecSearchService, private reportService: ReportViewerService, private router: Router, private store: Store<AppState>) {
    this.remoteOps = {
      paging: false,
      filtering: false,
      sorting: false,
      grouping: false,
      summary: false
    };

    this.store.select(getRegSearchState).pipe(take(1)).subscribe(data => {
      this.userInput = data;
      for (let city of this.userInput.city.citytowns[0].citytowns) {
        if (city.isChecked)
          this.towns.push(city.townAbbrev);
      }

      for (let doctype of this.userInput.doct[0].doctypes) {
        if (doctype.isChecked)
          this.doctypes.push(doctype.docCode);
      }

      
      //this.getDateResults(this.userInput.date[0].fromDate, this.userInput.date[0].toDate, this.towns, this.doctypes);

    });


    this.showFilterRow = true;
    this.applyFilterTypes = [{
      key: "auto",
      name: "Immediately"
    }, {
      key: "onClick",
      name: "On Button Click"
    }];

    this.currentFilter = this.applyFilterTypes[0].key;

  }

  mouseover(event) {
    //console.log(`onmouseover fired: ${JSON.stringify(event)}`);
    //console.log(`target: ${event.target.id}`);
    //this.infoFromServer = event.target.id;

    var docIDstring = (event.target.id as string).split('_')[1];
    this.console.log(`Our docId: ${docIDstring}`);
    var docID = Number(docIDstring);
    this.service.getRecDoc(docID).subscribe(data => {
      this.infoFromServer = `
<div style="text-align: left;">
      Grantors: <br />

`;
      data.docTors.forEach(tor => {
        this.infoFromServer +=  "&nbsp;&nbsp;" + tor.lastCorpName + " " + tor.fName + "<br />";
      });

      this.infoFromServer += "Grantees: <br />";
      data.docTees.forEach(tee => {
        this.infoFromServer += "&nbsp;&nbsp;" + tee.lastCorpName + " " + tee.fName + "<br />"
      });
      this.infoFromServer += "</div>"
    });
  }


  ngOnInit() {
    this.recsresults = new CustomStore({
      key: "docID",
      load: (loadOptions: any) => {
        let search = new GetRecDateSearchQuery({
          fromDate: this.userInput.date[0].fromDate,
          toDate: this.userInput.date[0].toDate,
          towns: this.towns,
          doctypes: this.doctypes
        });
        return this.service.getRecDateSearchResults(search).toPromise().then(data => {
          this.recordCount = data.recDateSearchRows.length;
          return {
            data: data.recDateSearchRows,
            totalCount: data.recDateSearchRows.length
          };
        }).catch(error => { throw 'Data Loading Error' });
      }
    });

  }

  getDateResults(fromdate, todate, towns, types) {
    let search = new GetRecDateSearchQuery({
      fromDate: fromdate,
      toDate: todate,
      towns: towns,
      doctypes: types
    });
    this.service.getRecDateSearchResults(search).subscribe(data => {
      this.recsresults = data.recDateSearchRows;
      this.recordCount = this.recsresults.length
    },

      error => this.errorMsg = error

    );


    //this.service.getDateSearchResults(fromdate, todate, towns, types).subscribe(data => {
    //  this.recsresults = data;
    //  this.recordCount = this.recsresults.length
    //},

    //  error => this.errorMsg = error

    //);
  }


  clearFilter() {
    this.dataGrid.instance.clearFilter();
  }

  onInitialized(e) {

  }

  //Open image in another tab'
  imgClicked(event) {
    if (!this.dataGrid.instance.isRowSelected(event.row.key)) {
      this.dataGrid.instance.selectRows(event.row.key, false);
    }
    // this.nav.visible = false;


  }

  onExpanding(e) {
    this.focusedRowKey = e.component.option("focusedRowIndex");
    this.focusedRowKey = e.key.index;
    e.component.collapseAll(-1);
  }

  assignTypes(filters: SearchFilter[]) {
    if (filters) {
      filters.forEach(fl => {
        if (fl.filterType == 'join') {
          this.assignTypes(fl.filters);
        } else {
          for (var prop in this.recsresults[0]) {
            if (prop == fl.fieldName) {
              fl.fieldType = typeof this.recsresults[0][prop];
            }
          }
        }

      });
    }
  }


  export() {

    var filtersUsed = this.dataGrid.instance.getCombinedFilter(true);// [["firstGrantor", "contains", "bed"], "and", ["firstGrantee", "contains", "or"], "and", ["recLandBook", "contains", "3"]];//[[["recordDate", "<", "2000-04-03T04:00:00.000Z"], "or", ["recordDate", ">=", "2000-04-04T04:00:00.000Z"]], "and", ["firstGrantor", "contains", "BED"]];//
    var filters = new Array<string>();
    var filterExpression = filtersUsed ? JSON.stringify(filtersUsed) : "";
    console.log(`filterExpression: ${filterExpression}`);
    var filterObjs = new Array<SearchFilter>();
    if (filterExpression) {
      var filtersOnGrid = SearchFilter.subHelper(filtersUsed, 0);
      filterObjs = [...filtersOnGrid];
      this.assignTypes(filterObjs);
      console.log(`filterObjs: ${JSON.stringify(filterObjs)}`);
      //filtersOnGrid.forEach(f => filters.push(JSON.stringify(f)));
      //console.log(`filters: ${JSON.stringify(filters)}`);
    }


    let query = new GetRecDateSearchReportQuery({
      fromDate: this.userInput.date[0].fromDate,
      toDate: this.userInput.date[0].toDate,
      towns: this.towns,
      doctypes: this.doctypes,
      sortBy: new Array<string>(),
      sortDirection: "desc",
      filterExpression: filterExpression,
      filterObjects: filterObjs
    });

    this.console.log(`query: ${JSON.stringify(query)}`);
    this.reportService.getRecDateSearchReport(query).subscribe(repName => {
      this.router.navigate([`/report-viewer/${repName.reportName}`]);
    });
  }

}
